import { CategoryHelper } from '..';

export const useCategory = () => {
	let categoryHelper = new CategoryHelper();
	return {
		categoryHelper,
		activeCategory: categoryHelper.active()
	};
};
